module.exports = __webpack_public_path__ + "img/095525470af5707acdccdcfcffde7c2e.e78fa5d0.png";